export default {"src":"/_next/static/media/clip-blue.3edbb87a.svg","height":13,"width":13};